import React, { Component } from "react";
import { ContentWrapper, Icon, Table } from "components";
import { Row, Col, Input, notification, Tabs, Drawer, Select, DatePicker, Modal, Tooltip } from "antd";
import { Column } from "@ant-design/plots";
import Dropzone from "react-dropzone";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { delayedDispatch, setBreadcrumb, setLoader, setTitle, updateCrumb } from "store/actions";
import { API, Endpoints } from "utils/api";
import Strings from "utils/strings";
import { push } from "connected-react-router";
import { DateTime } from "luxon";
import moment from "moment";
import { translate } from "utils/utils";
import pt from "antd/lib/date-picker/locale/pt_PT";
import en from "antd/lib/date-picker/locale/en_GB";
import "./styles.scss";

class VehicleDetail extends Component<any, any> {
	phoneValidationInput: any;

	constructor(props: any) {
		super(props);

		this.state = {
			vehicle: null,
			hasUnsavedFields: false,
			isNew: props.match?.params?.id === "new",
			tab: "1",
			showInterventionDrawer: false,
			selectedIntervention: null,
			startDate: moment().startOf("year"),
			endDate: moment().endOf("day"),
			averageConsumptionStatistics: [],
			showValueModal: null,
			tempWorksheet: null
		};
	}

	componentDidMount(): void {
		delayedDispatch(
			setBreadcrumb(() => {
				return {
					locations: [
						{
							text: Strings.sidebar.vehicles,
							route: "/vehicles",
							icon: "truck"
						},
						{
							text: this.state.isNew
								? Strings.vehicles.new
								: this.state.licensePlate || Strings.generic.loading
						}
					],
					actions: [
						{
							type: "button",
							text: Strings.generic.save,
							onClick: () => this.submitVehicle(),
							disabled: !this.state.hasUnsavedFields,
							className: this.state.hasUnsavedFields ? "BreadcrumbButtonSuccess" : "",
							isSave: true
						}
					]
				};
			})
		);

		this.getData();
	}

	componentDidUpdate(): void {
		const { dispatch } = this.props;

		dispatch(updateCrumb());
	}

	async getData() {
		const { isNew } = this.state;
		const { dispatch, match } = this.props;

		if (isNew) {
			return dispatch(setTitle(Strings.vehicles.new));
		}

		dispatch(setLoader(true));

		try {
			const response = await API.get({
				url: Endpoints.uriVehicles(match?.params?.id)
			});

			if (response.ok) {
				dispatch(setTitle(response.data?.results?.vehicle?.licensePlate || Strings.generic.loading));
				const vehicle = response.data?.results?.vehicle;
				this.setState({ 
					vehicle, 
					...vehicle,
					nextReviewDate: vehicle?.nextReviewDate ? moment(vehicle.nextReviewDate) : null
				}, () => {
					// Load analytics data when vehicle data is loaded
					this.getAnalyticsData();
				});
			}
		} catch (err) {
			console.log("API Error", err);
			notification.error({
				message: Strings.serverErrors.title,
				description: (err as string) || Strings.serverErrors.wentWrong,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	async submitVehicle() {
		const { licensePlate, type, avarage, nextReviewDate, nextReviewKm, isNew } = this.state;
		const { dispatch, match } = this.props;

		if (!licensePlate?.trim() || !type) {
			return notification.warn({
				message: Strings.vehicles.vehicle,
				description: Strings.errors.invalidFields,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(true));

		try {
			const request = !isNew ? API.put : API.post;
			console.log("request", request);
			const response = await request({
				url: Endpoints.uriVehicles((!isNew && match?.params?.id) || ""),
				data: {
					licensePlate,
					type,
					avarage,
					nextReviewDate: nextReviewDate ? (moment.isMoment(nextReviewDate) ? nextReviewDate.format("YYYY-MM-DD") : moment(nextReviewDate).format("YYYY-MM-DD")) : null,
					nextReviewKm: nextReviewKm || null
				}
			});

			if (response.ok && response.data.results?.vehicle) {
				if (isNew) {
					return dispatch(push("/vehicles"));
				}

				const updatedVehicle = response.data.results.vehicle;
				this.setState({
					hasUnsavedFields: false,
					vehicle: updatedVehicle,
					showDrawer: false,
					tempEntry: null,
					...updatedVehicle,
					nextReviewDate: updatedVehicle?.nextReviewDate ? moment(updatedVehicle.nextReviewDate) : null
				});

				dispatch(setTitle(response.data.results?.vehicle?.licensePlate));

				notification.success({
					message: Strings.vehicles.vehicle,
					description: response.data.message || "",
					placement: "bottomRight",
					duration: 5
				});
			} else {
				notification.error({
					message: Strings.serverErrors.title,
					description: response?.data?.message || Strings.serverErrors.wentWrong,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.serverErrors.title,
				description: (err as string) || Strings.serverErrors.wentWrong,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	async submitDocument() {
		const { tempEntry } = this.state;
		const { dispatch, match } = this.props;

		if (!tempEntry?.description?.trim() || !tempEntry?.file) {
			return notification.warn({
				message: Strings.staff.documents,
				description: Strings.errors.invalidFields,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(true));

		const body = new FormData();
		body.append("description", tempEntry.description);
		body.append("document", tempEntry.file);

		try {
			const request = tempEntry._id ? API.put : API.post;
			const response = await request({
				url: Endpoints.uriVehicles(`${match?.params?.id}/document/${tempEntry._id || ""}`),
				data: body
			});

			if (response.ok && response.data.results?.vehicle) {
				const updatedVehicle = response.data.results.vehicle;
				this.setState({
					showDrawer: false,
					tempEntry: null,
					vehicle: updatedVehicle,
					...updatedVehicle,
					nextReviewDate: updatedVehicle?.nextReviewDate ? moment(updatedVehicle.nextReviewDate) : null
				});

				notification.success({
					message: Strings.staff.documents,
					description: response.data.message || "",
					placement: "bottomRight",
					duration: 5
				});
			} else {
				notification.error({
					message: Strings.serverErrors.title,
					description: response?.data?.message || Strings.serverErrors.wentWrong,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.serverErrors.title,
				description: (err as string) || Strings.serverErrors.wentWrong,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	async removeDocument(id: string) {
		const { dispatch, match } = this.props;

		dispatch(setLoader(true));

		try {
			const response = await API.delete({
				url: Endpoints.uriVehicles(`${match?.params?.id}/document/${id}`)
			});

			if (response.ok) {
				const updatedVehicle = response.data?.results?.vehicle;
				this.setState({ 
					vehicle: updatedVehicle, 
					...updatedVehicle,
					nextReviewDate: updatedVehicle?.nextReviewDate ? moment(updatedVehicle.nextReviewDate) : null
				});

				notification.success({
					message: Strings.staff.documents,
					description: response.data.message || "",
					placement: "bottomRight",
					duration: 5
				});
			} else {
				notification.error({
					message: Strings.serverErrors.title,
					description: response?.data?.message || Strings.serverErrors.wentWrong,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.serverErrors.title,
				description: (err as string) || Strings.serverErrors.wentWrong,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	async changeWorksheet() {
		const { tempWorksheet } = this.state;
		const { dispatch } = this.props;

		dispatch(setLoader(true));

		try {
			const body = { 
				liters: tempWorksheet?.liters || 0,
				value: tempWorksheet?.value || 0,
				litersAdBlue: tempWorksheet?.litersAdBlue || 0,
				valueAdBlue: tempWorksheet?.valueAdBlue || 0,
				fullTank: tempWorksheet?.fullTank,
				km: tempWorksheet?.km || 0,
			} as any;

			const url = Endpoints.uriWorksheets(`values/${tempWorksheet?._id}/fuel/${tempWorksheet?.refuelId}`);

			const response = await API.patch({
				url: url,
				data: body
			});

			if (response.ok) {
				this.setState({ showValueModal: null, tempWorksheet: null })
				
				await this.getData();
				await this.getAnalyticsData();

				notification.success({
					message: Strings.worksheets.worksheets,
					description: response.data.message || "",
					placement: "bottomRight",
					duration: 5
				});
			} else {
				notification.error({
					message: Strings.serverErrors.title,
					description: response?.data?.message || Strings.serverErrors.wentWrong,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.serverErrors.title,
				description: (err as string) || Strings.serverErrors.wentWrong,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	handleDateSelect = (dates: any) => {
		if (dates && dates[0] && dates[1]) {
			this.setState(
				{
					startDate: moment(dates[0]).startOf("day"),
					endDate: moment(dates[1]).endOf("day")
				},
				() => this.getAnalyticsData()
			);
		}
	}

	getAnalyticsData = async () => {
		const { startDate, endDate } = this.state;
		const { dispatch, match } = this.props;

		if (!match?.params?.id || match?.params?.id === "new") return;

		dispatch(setLoader(true));

		try {
			const body = {
				startDate: startDate.format("DD/MM/yyyy"),
				endDate: endDate.format("DD/MM/yyyy"),
				vehicle: match.params.id
			};

			const response = await API.post({
				url: Endpoints.uriVehicleConsumptionAverage(),
				data: body
			});

			if (response?.ok) {
				const { chartData = [] } = response.data?.results || {};

				// Process chartData from new endpoint - always use DD/MM/yyyy format for daily bars
				const averageConsumptionStatistics: any[] = chartData.map((item: any) => {
					const dateMoment = moment(item.date);
					const formattedDate = dateMoment.format("DD/MM/yyyy");
					
					return {
						day: formattedDate,
						value: item.value
					};
				});

				// Sort by date to ensure proper order
				averageConsumptionStatistics.sort((a, b) => {
					return moment(a.day, "DD/MM/yyyy").valueOf() - moment(b.day, "DD/MM/yyyy").valueOf();
				});

				console.log("Vehicle consumption average data:", chartData);
				console.log("Average consumption statistics:", averageConsumptionStatistics);
				this.setState({ averageConsumptionStatistics });
			} else {
				console.log("Vehicle consumption average response not ok:", response);
			}
		} catch (err) {
			console.log("Vehicle consumption average Error", err);
		}

		dispatch(setLoader(false));
	}

	onDropFile = async (files: any) => {
		try {
			this.setState((state: any) => ({
				tempEntry: {
					...state.tempEntry,
					file: files[files.length - 1]
				}
			}));
		} catch (err) {
			console.log("err", err);
			notification.warn({
				message: Strings.errors.unsupportedFile,
				description: Strings.errors.fileNotSupported,
				placement: "bottomRight",
				duration: 5
			});
		}
	};

	getType(type: string) {
		if (type === "truck") return Strings.vehicles.truck;
		if (type === "van") return Strings.vehicles.van;
		if (type === "car") return Strings.vehicles.car;
		return type;
	}

	getStatus(status: string) {
		if (status === "pending") return Strings.worksheets.pending;
		if (status === "started") return Strings.worksheets.started;
		if (status === "finished") return Strings.worksheets.finished;
		return status;
	}

	renderWorksheets() {
		const { worksheets = [] } = this.state;

		return (
			<Table
				title={{
					icon: "duplicate",
					title: Strings.worksheets.worksheets
				}}
				data={worksheets}
				columns={[
					{
						Header: Strings.fields.date,
						id: "date",
						accessor: (row: any) => row.date && DateTime.fromISO(row.date).toFormat("dd/MM/yyyy"),
						minWidth: 50
					},
					{
						Header: Strings.fields.number,
						id: "number",
						minWidth: 50,
						accessor: (row: any) => row.number
					},
					{
						Header: Strings.staff.driver,
						id: "staff",
						minWidth: 150,
						accessor: (row: any) => row.driver
					},
					{
						Header: Strings.customers.customer,
						id: "name",
						minWidth: 150,
						accessor: (row: any) => row.customer
					},
					{
						Header: Strings.worksheets.status,
						id: "status",
						minWidth: 70,
						accessor: (row: any) => this.getStatus(row.status) || "-"
					},
					{
						Header: Strings.worksheets.exitHour,
						id: "exitHour",
						minWidth: 70,
						accessor: (row: any) =>
							(row.exitHour && DateTime.fromISO(row.exitHour).toFormat("HH:mm")) || "-"
					},
					{
						Header: Strings.worksheets.returnHour,
						id: "returnHour",
						minWidth: 70,
						accessor: (row: any) =>
							(row.returnHour && DateTime.fromISO(row.returnHour).toFormat("HH:mm")) || "-"
					},
					{
						Header: Strings.worksheets.exitKm,
						id: "exitKm",
						minWidth: 70,
						align: "right",
						accessor: (row: any) => row.exitKm || "-"
					},
					{
						Header: Strings.worksheets.returnKm,
						id: "returnKm",
						minWidth: 70,
						align: "right",
						accessor: (row: any) => row.returnKm || "-"
					}
				]}
				filterable
				paginated={true}
			/>
		);
	}

	renderRefuels() {
		const { refuels = [], startDate, endDate, averageConsumptionStatistics } = this.state;
		const { RangePicker } = DatePicker;

		// Filter refuels locally by date range
		const filteredRefuels = refuels.filter((refuel: any) => {
			if (!refuel.date) return false;
			const refuelDate = moment(refuel.date);
			return refuelDate.isSameOrAfter(startDate, "day") && refuelDate.isSameOrBefore(endDate, "day");
		});

		const chartConfig = {
			data: averageConsumptionStatistics || [],
			xField: "day",
			yField: "value",
			xAxis: {
				label: {
					autoRotate: true,
					autoHide: false,
					autoEllipsis: false
				}
			},
			yAxis: {
				label: {
					formatter: function formatter(v: string) {
						return "".concat(v).replace(/\d{1,3}(?=(\d{3})+$)/g, function (s) {
							return "".concat(s, ",");
						});
					}
				},
				visible: true,
				min: 0
			},
			columnWidthRatio: 0.6,
			minColumnWidth: 20,
			maxColumnWidth: 100,
			appendPadding: [10, 10, 10, 50],
			animation: {
				appear: {
					animation: "scale-in-y",
					duration: 2500
				}
			}
		};

		let locale;
		switch (Strings.getLanguage()) {
			case "en":
				locale = en;
				break;
			case "pt":
				locale = pt;
				break;
			default:
				locale = pt;
		}

		return (
			<React.Fragment>
				<ContentWrapper extraStyle={{ marginBottom: 20 }}>
					<Row gutter={[20, 20]} style={{ marginBottom: 20 }}>
						<Col>
							<label className="InputLabel">{Strings.dashboard.period}:</label>
							<RangePicker
								locale={locale}
								allowEmpty={[false, false]}
								ranges={{
									[Strings.ranges.today]: [moment(), moment()],
									[Strings.ranges.thisMonth]: [moment().startOf("month"), moment().endOf("month")],
									[Strings.ranges.lastMonth]: [
										moment().subtract(1, "month").startOf("month"),
										moment().subtract(1, "month").endOf("month")
									],
									[Strings.ranges.thisYear]: [moment().startOf("year"), moment().endOf("month")],
									[Strings.ranges.lastYear]: [
										moment().subtract(1, "year").startOf("year"),
										moment().subtract(1, "year").endOf("year")
									]
								}}
								placeholder={[Strings.fields.startDate, Strings.fields.endDate]}
								separator={<Icon name="arrow-up" className="__turn90" />}
								value={[startDate, endDate]}
								onChange={this.handleDateSelect}
								format="DD/MM/YYYY"
								style={{ marginLeft: 10 }}
							/>
						</Col>
					</Row>
				</ContentWrapper>
				<Table
					title={{
						icon: "expenses",
						title: Strings.worksheets.refuels
					}}
					data={filteredRefuels}
					actions={{
						edit: (original: any) => ({
							onClick: () => {
								console.log("Edit clicked, original data:", original);
								this.setState({ showValueModal: true, tempWorksheet: { ...original } })
							}
						}),
					}}
					columns={[
						{
							Header: Strings.fields.date,
							id: "date",
							accessor: (row: any) => row.date && DateTime.fromISO(row.date).toFormat("dd/MM/yyyy"),
							minWidth: 50
						},
						{
							Header: Strings.fields.number,
							id: "number",
							minWidth: 50,
							accessor: (row: any) => row.number
						},
						{
							Header: Strings.staff.driver,
							id: "staff",
							minWidth: 150,
							accessor: (row: any) => row.driver
						},
						{
							Header: Strings.worksheets.notes,
							id: "name",
							minWidth: 150,
							accessor: (row: any) => row.notes
						},
						{
							Header: Strings.vehicles.kms,
							id: "km",
							minWidth: 70,
							align: "right",
							accessor: (row: any) => row.km
						},
						{
							Header: Strings.worksheets.amount,
							id: "value",
							minWidth: 70,
							align: "right",
							accessor: (row: any) => (row.value && `${row.value} €`) || "-"
						},
						{
							Header: Strings.worksheets.liters,
							id: "liters",
							minWidth: 70,
							align: "right",
							accessor: (row: any) => row.liters || 0
						},
						{
							Header: Strings.worksheets.amountAdBlue,
							id: "valueAdBlue",
							minWidth: 70,
							align: "right",
							accessor: (row: any) => (row.valueAdBlue && `${row.valueAdBlue} €`) || "-"
						},
						{
							Header: Strings.worksheets.litersAdBlue,
							id: "litersAdBlue",
							minWidth: 70,
							align: "right",
							accessor: (row: any) => row.litersAdBlue || 0
						},
						{
							Header: Strings.worksheets.fullTank,
							id: "fullTank",
							minWidth: 70,
							align: "right",
							accessor: (row: any) => row.fullTank === true ? "Sim" : row.fullTank === false ? "Não" : "-",
						},
						{
							Header: Strings.vehicles.avarage,
							id: "averageConsumption",
							minWidth: 70,
							align: "right",
							accessor: (row: any) => row.averageConsumption ? row.averageConsumption.toFixed(2) : "-"
						}
					]}
					fullPage
					paginated
					pageSize={100}
				/>
				<ContentWrapper extraStyle={{ padding: 20, marginBottom: 20 }}>
					<div className="DashboardMainChart">
						<div className="DashboardMainChartTitle">
							<Icon name={"truck"} />
							<span>{Strings.dashboard.averageConsumptionDetails}</span>
						</div>
						<div className="Dashboard_Data_Charts">
							<div id="data1" className={"Dashboard_Generic_Chart$ __active"}>
								{averageConsumptionStatistics.length > 0 ? (
									<Column {...chartConfig} />
								) : (
									<div style={{ padding: 20, textAlign: "center" }}>
										<p>Nenhum dado disponível para o período selecionado</p>
									</div>
								)}
							</div>
						</div>
					</div>
				</ContentWrapper>
			</React.Fragment>
		);
	}

	renderInterventions() {
		const { interventions = [] } = this.state;

		return (
			<Table
				title={{
					icon: "inspection",
					title: Strings.workshop.interventions
				}}
				data={interventions}
				columns={[
					{
						Header: Strings.workshop.date,
						id: "date",
						accessor: (row: any) => row.date && DateTime.fromISO(row.date).toFormat("dd/MM/yyyy"),
						minWidth: 50
					},
					{
						Header: Strings.workshop.currentKm,
						id: "km",
						minWidth: 70,
						align: "right",
						accessor: (row: any) => row.km || "-"
					},
					{
						Header: Strings.workshop.nextReviewDate,
						id: "nextReviewDate",
						minWidth: 70,
						accessor: (row: any) =>
							(row.nextReviewDate && DateTime.fromISO(row.nextReviewDate).toFormat("dd/MM/yyyy")) || "-"
					},
					{
						Header: Strings.workshop.nextReviewKm,
						id: "nextReviewKm",
						minWidth: 70,
						align: "right",
						accessor: (row: any) => row.nextReviewKm || "-"
					},
					{
						Header: Strings.workshop.items,
						id: "items",
						minWidth: 70,
						align: "right",
						accessor: (row: any) => (row.items?.length || 0) + " " + Strings.workshop.items
					},
					{
						Header: Strings.workshop.total,
						id: "total",
						minWidth: 70,
						align: "right",
						accessor: (row: any) => (row.total && `${row.total.toFixed(2)} €`) || "-"
					}
				]}
				filterable
				paginated={true}
				actions={{
					view: (original: any) => ({
						onClick: () => this.setState({ showInterventionDrawer: true, selectedIntervention: original })
					})
				}}
			/>
		);
	}

	renderValueModal() {
		const { showValueModal, tempWorksheet } = this.state;

		console.log("renderValueModal - showValueModal:", showValueModal, "tempWorksheet:", tempWorksheet);

		// Show modal for fuel refuels (check if it has fuelId or if it's a refuel from the refuels table)
		if (!showValueModal || !tempWorksheet) {
			return null;
		}

		// For fuel refuels, show the fuel modal
		if (tempWorksheet?.fuelId || (tempWorksheet?.liters !== undefined || tempWorksheet?.value !== undefined)) {
			return (
				<Modal
					centered
					width="500px"
					visible={!!showValueModal}
					cancelButtonProps={{ className: "displayNone" }}
					okButtonProps={{ className: "displayNone" }}
					onCancel={() => {
						this.setState({ showValueModal: null, tempWorksheet: null });
					}}
					onOk={async () => {
						this.setState({ showValueModal: null });
						await this.changeWorksheet();
					}}
				>
					<div className="title" style={{ paddingBottom: 20, paddingTop: 20 }}>
						{`Indique os valores do abastecimento da viatura ${this.state.licensePlate} no trabalho ${tempWorksheet?.number} na data ${DateTime.fromISO(tempWorksheet?.date).toFormat("dd/MM/yyyy")}`}
					</div>
					<Row gutter={[24, 24]}>
						<Col xs={12}>
							<label htmlFor="fuel_km" className="InputLabel">
								{Strings.vehicles.kms}
							</label>
							<Input
								id="fuel_km"
								type="number"
								value={tempWorksheet?.km}
								placeholder={Strings.vehicles.kms}
								onChange={(e: any) => {
									const km = e.target.value;
									this.setState((state: any) => ({ tempWorksheet: { ...state.tempWorksheet, km }}));
								}}
							/>
						</Col>
						<Col xs={12}>
							<label htmlFor="fuel_liters" className="InputLabel">
								{Strings.worksheets.liters}
							</label>
							<Input
								id="value"
								type="number"
								value={tempWorksheet?.liters}
								placeholder={Strings.worksheets.liters}
								addonAfter="L"
								onChange={(e: any) => {
									const liters = e.target.value;
									this.setState((state: any) => ({ tempWorksheet: { ...state.tempWorksheet, liters }}));
								}}
							/>
						</Col>
					</Row>
					<Row gutter={[24, 24]}>
						<Col xs={12}>
							<label htmlFor="fuel_value" className="InputLabel">
								{Strings.worksheets.amount}
							</label>
							<Input
								id="value"
								type="number"
								value={tempWorksheet?.value}
								placeholder={Strings.worksheets.amount}
								addonAfter="€"
								onChange={(e: any) => {
									const value = e.target.value;
									this.setState((state: any) => ({ tempWorksheet: { ...state.tempWorksheet, value }}));
								}}
							/>
						</Col>
					</Row>
					<Row gutter={[24, 24]}>
						<Col xs={12}>
							<label htmlFor="fuel_litersAdBlue" className="InputLabel">
								{Strings.worksheets.litersAdBlue}
							</label>
							<Input
								id="value"
								type="number"
								value={tempWorksheet?.litersAdBlue}
								placeholder={Strings.worksheets.litersAdBlue}
								addonAfter="L"
								onChange={(e: any) => {
									const litersAdBlue = e.target.value;
									this.setState((state: any) => ({ tempWorksheet: { ...state.tempWorksheet, litersAdBlue }}));
								}}
							/>
						</Col>
						<Col xs={12}>
							<label htmlFor="fuel_value" className="InputLabel">
								{Strings.worksheets.amountAdBlue}
							</label>
							<Input
								id="value"
								type="number"
								value={tempWorksheet?.valueAdBlue}
								placeholder={Strings.worksheets.amountAdBlue}
								addonAfter="€"
								onChange={(e: any) => {
									const valueAdBlue = e.target.value;
									this.setState((state: any) => ({ tempWorksheet: { ...state.tempWorksheet, valueAdBlue }}));
								}}
							/>
						</Col>
					</Row>
					<Row gutter={[24, 24]}>
						<Col xs={24}>
							<label htmlFor="fuel_fullTank" className="InputLabel">
								{Strings.worksheets.fullTank}
							</label>
							<Select
								id="fuel_fullTank"
								className="tagsSelector"
								style={{ width: "100%" }}
								placeholder={Strings.worksheets.fullTank}
								value={tempWorksheet?.fullTank === true ? "Sim" : tempWorksheet?.fullTank === false ? "Não" : undefined}
								onChange={(value: string) => {
									this.setState((state: any) => ({
										tempWorksheet: {
											...state.tempWorksheet,
											fullTank: value === "Sim"
										}
									}));
								}}
							>
								<Select.Option value="Sim">Sim</Select.Option>
								<Select.Option value="Não">Não</Select.Option>
							</Select>
						</Col>
					</Row>
				</Modal>
			);
		}

		return null;
	}

	renderDocuments() {
		const { documents = [] } = this.state;

		return (
			<Table
				title={{
					icon: "working-briefcase",
					title: Strings.staff.documents
				}}
				data={documents}
				columns={[
					{
						Header: Strings.fields.name,
						id: "description",
						accessor: (row: any) => row.description
					}
				]}
				filterable
				paginated={false}
				add={{
					onClick: () => this.setState({ tempEntry: {}, showDrawer: true, drawerType: "documents" })
				}}
				actions={{
					edit: (original: any) => ({
						onClick: () => this.setState({ tempEntry: { ...original }, showDrawer: true })
					}),
					view: (original: any) => ({
						onClick: () => window.open(original.file)
					}),
					remove: (original: any) => ({
						onClick: () => this.removeDocument(original._id)
					})
				}}
			/>
		);
	}

	renderInterventionDrawer() {
		const { showInterventionDrawer, selectedIntervention } = this.state;

		if (!selectedIntervention) return null;

		return (
			<Drawer
				title={
					<div className="SidebarTitleContainer">
						<Icon name="inspection" />
						<p>
							{Strings.workshop.intervention} -{" "}
							{selectedIntervention.date && DateTime.fromISO(selectedIntervention.date).toFormat("dd/MM/yyyy")}
						</p>
					</div>
				}
				footer={
					<div className="SidebarFooterContainer">
						<button
							type="button"
							className="SidebarFooterButton --button-cancel"
							onClick={() => this.setState({ showInterventionDrawer: false, selectedIntervention: null })}
						>
							{Strings.generic.close}
						</button>
					</div>
				}
				placement="right"
				width={500}
				onClose={() => this.setState({ selectedIntervention: null, showInterventionDrawer: false })}
				visible={showInterventionDrawer}
			>
				<div style={{ marginBottom: 20 }}>
					<label className="InputLabel">{Strings.workshop.total}:</label>
					<div style={{ fontSize: 18, fontWeight: 700 }}>
						{selectedIntervention.total?.toFixed(2)} €
					</div>
				</div>
				<div>
					<Table
						data={selectedIntervention.items || []}
						columns={[
							{
								Header: Strings.workshop.items,
								id: "item",
								accessor: (row: any) =>
									row.type === "service"
										? row.description || "-"
										: translate(row.part?.name) || row.part?.partNumber || "-",
								Cell: ({ row }: any) => {
									const item = row.original;
									const description =
										item.type === "service"
											? item.description || "-"
											: translate(item.part?.name) || item.part?.partNumber || "-";
									const qty = item.quantity != null ? item.quantity : "-";
									const unitPrice =
										item.unitPrice != null ? `${item.unitPrice.toFixed(2)} €` : "-";
									const total = item.total != null ? `${item.total.toFixed(2)} €` : "-";
									return (
										<div style={{ padding: "4px 0" }}>
											<Tooltip title={description} placement="topLeft">
												<div
													style={{
														overflow: "hidden",
														textOverflow: "ellipsis",
														whiteSpace: "nowrap"
													}}
												>
													{description}
												</div>
											</Tooltip>
											<div
												style={{
													fontSize: 12,
													color: "rgba(0,0,0,0.45)",
													marginTop: 2
												}}
											>
												{Strings.workshop.quantity}: {qty}
												{" · "}
												{Strings.workshop.unitPrice}: {unitPrice}
												{" · "}
												{Strings.workshop.total}: {total}
											</div>
										</div>
									);
								}
							}
						]}
						filterable={false}
						isSinglePage
						fullPage={false}
						paginated={false}
					/>
				</div>
			</Drawer>
		);
	}

	renderDrawer() {
		const { showDrawer } = this.state;

		return (
			<Drawer
				title={
					<div className="SidebarTitleContainer">
						<Icon name={"working-briefcase"} />
						<p>{Strings.staff.documents}</p>
					</div>
				}
				footer={
					<div className="SidebarFooterContainer">
						<button
							type="button"
							className="SidebarFooterButton --button-confirm"
							onClick={() => {
								this.submitDocument();
							}}
						>
							{Strings.generic.confirm}
						</button>
						<button
							type="button"
							className="SidebarFooterButton --button-cancel"
							onClick={() => this.setState({ openSidebar: false, tempEntry: null })}
						>
							{Strings.generic.cancel}
						</button>
					</div>
				}
				placement="right"
				width={400}
				onClose={() => this.setState({ tempEntry: null, showDrawer: false })}
				visible={showDrawer}
			>
				{this.renderDrawerContent()}
			</Drawer>
		);
	}

	renderDrawerContent() {
		const { tempEntry } = this.state;

		return (
			<Row gutter={[0, 10]}>
				<Col xs={24}>
					<label htmlFor="document_descritpion" className="InputLabel --label-required">
						{Strings.fields.description}
					</label>
					<Input
						id="document_descritpion"
						value={tempEntry?.description || ""}
						placeholder={Strings.fields.description}
						onChange={(event: any) => {
							const value = event.target.value;
							this.setState((state: any) => ({
								tempEntry: { ...state.tempEntry, description: value }
							}));
						}}
					/>
				</Col>
				<Col xs={24}>
					<label htmlFor="document_file" className="InputLabel --label-required">
						{Strings.fields.file}
					</label>
					<Dropzone
						accept=".pdf, .png, .jpg, .jpeg"
						multiple={false}
						style={{ cursor: "pointer" }}
						className="ant-input"
						onDrop={(files) => this.onDropFile(files)}
					>
						<div className="FileUpload">
							<Icon
								name="document"
								style={{ marginRight: "10px", color: tempEntry?.file ? "#333" : "#bfbfbf" }}
							/>
							<span
								style={{
									color: tempEntry?.file ? "#333" : "#bfbfbf",
									fontSize: 12,
									wordBreak: "break-all"
								}}
							>
								{tempEntry?.file
									? typeof tempEntry.file === "string"
										? tempEntry.file
										: tempEntry.file.name
									: Strings.fields.clickToUpload}
							</span>
						</div>
					</Dropzone>
				</Col>
			</Row>
		);
	}

	render(): JSX.Element {
		const { isNew, licensePlate, type, avarage, tab } = this.state;

		return (
			<React.Fragment>
				<Helmet>
					<title>
						{Strings.vehicles.vehicle} -{" "}
						{isNew ? Strings.vehicles.new : licensePlate || Strings.generic.loading}
					</title>
					<meta name="description" content="Description of Vehicle" />
				</Helmet>
				<div className="VehicleScreen">
					<ContentWrapper extraClass="VehicleContainer">
						<Row gutter={[20, 10]}>
							<Col xs={8}>
								<label htmlFor="license_plate" className="InputLabel --label-required">
									{Strings.vehicles.licensePlate}
								</label>
								<Input
									id="license_plate"
									placeholder={Strings.vehicles.licensePlate}
									value={licensePlate || ""}
									onChange={(event: any) => {
										this.setState({ licensePlate: event.target.value, hasUnsavedFields: true });
									}}
								/>
							</Col>
							<Col xs={8}>
								<label htmlFor="type" className="InputLabel --label-required">
									{Strings.vehicles.type}
								</label>
								<Select
									id="type"
									className="tagsSelector"
									style={{ width: "100%" }}
									placeholder={Strings.vehicles.type}
									showSearch
									filterOption={(input: any, option: any) =>
										option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
									}
									value={type || null}
									onChange={(value: any) => {
										this.setState({ type: value, hasUnsavedFields: true });
									}}
								>
									<Select.Option value="truck">{Strings.vehicles.truck}</Select.Option>
									<Select.Option value="van">{Strings.vehicles.van}</Select.Option>
									<Select.Option value="car">{Strings.vehicles.car}</Select.Option>
								</Select>
							</Col>
							<Col xs={8}>
								<label htmlFor="avarage" className="InputLabel --label-required">
									{Strings.vehicles.avarage}
								</label>
								<Input
									id="avarage"
									type="number"
									placeholder={Strings.vehicles.avarage}
									value={avarage || ""}
									onChange={(e: any) => {
										const avarage = e.target.value;
										this.setState({ avarage, hasUnsavedFields: true });
									}}
								/>
							</Col>
							<Col xs={8}>
								<label htmlFor="nextReviewDate" className="InputLabel">
									{Strings.workshop.nextReviewDate}
								</label>
								<DatePicker
									id="nextReviewDate"
									style={{ width: "100%" }}
									locale={Strings.getLanguage() === "en" ? en : pt}
									value={this.state.nextReviewDate ? (moment.isMoment(this.state.nextReviewDate) ? this.state.nextReviewDate : moment(this.state.nextReviewDate)) : null}
									onChange={(date: any) => {
										this.setState({ nextReviewDate: date, hasUnsavedFields: true });
									}}
									format="DD/MM/YYYY"
								/>
							</Col>
							<Col xs={8}>
								<label htmlFor="nextReviewKm" className="InputLabel">
									{Strings.workshop.nextReviewKm}
								</label>
								<Input
									id="nextReviewKm"
									type="number"
									value={this.state.nextReviewKm || ""}
									placeholder={Strings.workshop.nextReviewKm}
									onChange={(e: any) => {
										const nextReviewKm = e.target.value;
										this.setState({ nextReviewKm, hasUnsavedFields: true });
									}}
								/>
							</Col>
						</Row>
					</ContentWrapper>
					{!isNew && (
						<ContentWrapper extraStyle={{ padding: 20 }}>
							<Tabs 
								onChange={(key: string) => {
									this.setState({ tab: key }, () => {
										// Load analytics data when refuels tab is selected
										if (key === "2") {
											this.getAnalyticsData();
										}
									});
								}} 
								defaultActiveKey="1"
							>
								<Tabs.TabPane tab={Strings.worksheets.refuels} key="1" />
								<Tabs.TabPane tab={Strings.worksheets.worksheets} key="2" />
								<Tabs.TabPane tab={Strings.workshop.interventions} key="3" />
								<Tabs.TabPane tab={Strings.staff.documents} key="4" />
							</Tabs>
							{tab === "1" && this.renderRefuels()}
							{tab === "2" && this.renderWorksheets()}
							{tab === "3" && this.renderInterventions()}
							{tab === "4" && this.renderDocuments()}
						</ContentWrapper>
					)}
				</div>
				{this.renderDrawer()}
				{this.renderInterventionDrawer()}
				{this.renderValueModal()}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any) => ({
	language: state.language
});

export default connect(mapStateToProps)(VehicleDetail);
